<template>
  <navbar>
    <my-button @click="$router.push('/profile')">profile</my-button>
  </navbar>

  <div class="cocktails">
    <div class="filter">
      <button class="filter_big_btn" @click="get_cocktails('alc')"
        :class="{'filter_big_btn_gray': filter == 'no'}">
        алкогольные
      </button>
      <button class="filter_big_btn" @click="get_cocktails('no')"
        :class="{'filter_big_btn_gray': filter == 'alc'}">
        безалкогольные
      </button>
    </div>
    <div>
      <cocktail v-for="cocktail in cocktails" :cocktail="cocktail" :key="cocktail.id"></cocktail>
      <!-- <cocktail v-for="cocktail in cocktails" повторить этот блок-->
      <!-- :cocktail="cocktail" пропс, прокинуть в компонент-->
      <!-- :key="cocktail.id"></cocktail> id для... надо-->
    </div>
  </div>
</template>


<script>
import Navbar from '@/components/Navbar.vue';
import Cocktail from '@/components/Cocktail.vue';
// import ky from 'ky';

export default {
  components: {
    Navbar, Cocktail
  },
  data() {
    return {
      filter: '',
      cocktails: [],
    }
  },
  methods: {
    async get_cocktails(alc_or_no) {
      if (this.filter === alc_or_no) {
        this.filter = '';
      } else {
        this.filter = alc_or_no;
      }
      // const data = await ky.post('http://127.0.0.1:48448/bar/filter', {
      //   json: {
      //     alc_filter: alc_or_no,
      //   }
      // }).json();
      let res = await fetch('/api/bar/filter', {
      // let res = await fetch('/auth/log_in', {
        method: "POST",
        headers: {"content-type": "application/json"},
        body: JSON.stringify({
          // alc_filter: alc_or_no,
          alc_filter: this.filter,
        })
      });

      if (res.status === 200) {
        let data = await res.json();
        // console.log(res);
        // console.log('data =>', data);
        this.cocktails = data['cocktails'];
        // console.log('cocktails =>', this.cocktails);
      }
    },
    async isauth() {
      let res = await fetch('/api/auth/isauth', {
        method: "POST",
        headers: {"content-type": "application/json"},
      });
      if (res.status === 200) {
        let data = await res.json();
        // console.log(data['auth']);
        if (!data['auth']) {
          this.$router.push('/auth/log_in');
        }
      }
    }
  },
  mounted() {
    this.isauth();
    this.get_cocktails('');
  }
}
</script>


<style scoped>
.cocktails {
    padding: 35px;
}

.filter {
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
}
.filter_big_btn {
  /* display: flex; */
  font-size: 45px;
  color: #ff7d33;
  /* color: darkorange; */
  text-decoration: underline;
  /* background-color: darkorange; */
  background-color: transparent;
  border: 2px solid transparent;
  border-radius: 15px;
  padding: 5px;
  margin-top: 5px;
  &:hover {
    background-color: #fae5d3;
  }
  &:active {
    border: 2px solid #ff7d33;
  }
}
.filter_big_btn_gray {
  color: gray;
}
</style>
